import React, { useState } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'

import Sidebar from './Components/CommonComponents/AdminCommonCom/Sidebar'
import AdminLoginPage from './Components/LoginPages/AdminLoginPage'
import StudentLoginPage from './Components/LoginPages/StudentLoginPage'
import ProtectedRoute from './Components/CommonComponents/ProtectedRoutes'
import './App.css'
import RoomMaster from './Components/AdminComponents/Masters/RoomMaster'
import BedMaster from './Components/AdminComponents/Masters/BedMaster'
import EventMaster from './Components/AdminComponents/Masters/EventMaster'
import FeeMaster from './Components/AdminComponents/Masters/FeeMaster'
import StudentRegistrationPage1 from './Components/StudentComponents/RegistrationPages/StudentRegistrationPage1'
import StudentRegistrationPage2 from './Components/StudentComponents/RegistrationPages/StudentRegistrationPage2'
import ReligionMaster from './Components/AdminComponents/Masters/ReligionMaster'
import CasteMaster from './Components/AdminComponents/Masters/CasteMaster'
// import SubCasteMaster from "./Components/AdminComponents/Masters/SubCasteMaster";
import RegApprovedList from './Components/AdminComponents/Admission/RegApprovedList'
import RegAppPendingList from './Components/AdminComponents/ApprovalPendings/RegAppPendingList'
import Dashboard from './Components/AdminComponents/Dashboard'
import CreateCertificate from './Components/AdminComponents/CreateCertificate'
import RegistrationControl from './Components/AdminComponents/RegistrationControl'
import StudentRegistrationPage3 from './Components/StudentComponents/RegistrationPages/StudentRegistrationPage3'
import StudentDashboard from './Components/StudentComponents/AfterLoginPages/StudentDashboard'
import AllotedRoomBedDetails from './Components/StudentComponents/AfterLoginPages/AllotedRoomBedDetails'
import Header from './Components/CommonComponents/AdminCommonCom/Header'
import StudentSidebar from './Components/CommonComponents/StudentCommonCom/StudentSidebar'
import StudentHeader from './Components/CommonComponents/StudentCommonCom/StudentHeader'
import AttendanceReport from './Components/StudentComponents/AfterLoginPages/AttendanceReport'
import ProfileDetails from './Components/StudentComponents/AfterLoginPages/ProfileDetails'
import PaymentDetails from './Components/StudentComponents/AfterLoginPages/PaymentDetails'
import LeaveApplication from './Components/StudentComponents/AfterLoginPages/LeaveApplication'
import ComplaintApplication from './Components/StudentComponents/AfterLoginPages/ComplaintApplication'
import HostelFeePayment from './Components/StudentComponents/AfterLoginPages/HostelFeePayment'
import HostelFeeAppPendingList from './Components/AdminComponents/ApprovalPendings/HostelFeeAppPendingList'
import LeaveAppPendingList from './Components/AdminComponents/ApprovalPendings/LeaveAppPendingList'
import AdminLoginPage2 from './Components/LoginPages/AdminLoginPage2'
import FeeAmountMaster from './Components/AdminComponents/Masters/FeeAmountMaster'
import ComplaintAppPendingList from './Components/AdminComponents/ApprovalPendings/ComplaintAppPendingList'
import StudentFooter from './Components/CommonComponents/StudentCommonCom/StudentFooter'
import Footer from './Components/CommonComponents/AdminCommonCom/Footer'
import StudentRoomChange from './Components/AdminComponents/RoomChange/StudentRoomChange'
import HostelFeeApprovedList from './Components/AdminComponents/Admission/HostelFeeApprovedList'
import LeaveAppList from './Components/AdminComponents/Admission/LeaveAppList'
import RoomAllotmentList from './Components/AdminComponents/RoomChange/RoomAllotmentList'
import RoomChangedHistory from './Components/AdminComponents/RoomChange/RoomChangedHistory'
import StudentDailyAttendance from './Components/AdminComponents/Attendance/StudentDailyAttendance'
import AttendedStudentList from './Components/AdminComponents/Attendance/AttendedStudentList'
import EventAttendedList from './Components/AdminComponents/Attendance/EventAttendedList'
import StudentEventAttendance from './Components/AdminComponents/Attendance/StudentEventAttendace'
import TermsAndConditionMaster from './Components/AdminComponents/Masters/TermsAndConditionMaster'
import StudentMandirAttendance from './Components/AdminComponents/Attendance/StudentMandirAttendance'
import MandirAttendedList from './Components/AdminComponents/Attendance/MandirAttendedList'
import EventAttendanceReport from './Components/StudentComponents/AfterLoginPages/EventAttendanceReport'
import MandirAttendanceReport from './Components/StudentComponents/AfterLoginPages/MandirAttendanceReport'
import ClassMaster from './Components/AdminComponents/Masters/ClassMaster'
import ConcessionApprovedList from './Components/AdminComponents/Admission/ConcessionApprovedList'
import CategoryMaster from './Components/AdminComponents/Masters/CategoryMaster'
import AlumniLoginPage from './Components/LoginPages/AlumniLoginPage'
import AlumniRegistrationPage from './Components/LoginPages/AlumniRegistrationPage'
import AlumniSidebar from './Components/CommonComponents/AlumniCommonCom/AlumniSidebar'
import AlumniHeader from './Components/CommonComponents/AlumniCommonCom/AlumniHeader'
import AlumniFooter from './Components/CommonComponents/AlumniCommonCom/AlumniFooter'
import AlumniCreation from './Components/AlumniComponents/AlumniCreation'
import AlumniJobPost from './Components/AlumniComponents/AlumniJobPost'
import AlumniAppPendingList from './Components/AdminComponents/ApprovalPendings/AlumniAppPendingList'
import AlumniApprovedList from './Components/AdminComponents/Admission/AlumniApprovedList'
import AlumniDashboard from './Components/AlumniComponents/AlumniDashboard'
import JobPost from './Components/AdminComponents/JobPost'
import AllJobPostDetails from './Components/StudentComponents/AfterLoginPages/AllJobPostDetails'
import AlumniProfile from './Components/AlumniComponents/AlumniProfile'
import PendingInterviewList from './Components/AdminComponents/ApprovalPendings/PendingInterviewList'
import InterviewPassedList from './Components/AdminComponents/Admission/InterviewPassedList'
import RejectedStudentList from './Components/AdminComponents/ApprovalPendings/RejectedStudentList'
import ChangePasswordAdmin from './Components/CommonComponents/AdminCommonCom/ChangePasswordAdmin'
import RoomAllocationList from './Components/AdminComponents/Admission/RoomAllocationList'
import DocumentAppPendingList from './Components/AdminComponents/ApprovalPendings/DocumentAppPendingList'
import DocumentApprovedList from './Components/AdminComponents/Admission/DocumentApprovedList'
import DocumentRejectedStudentList from './Components/AdminComponents/ApprovalPendings/DocumentRejectedStudentList'
import PendingRoomAllotment from './Components/AdminComponents/ApprovalPendings/PendingRoomAllotment'

export default function App() {
  // ✅ Initialize from sessionStorage immediately
  // const storedRole = sessionStorage.getItem('username')

  // const [user, setUser] = useState(storedRole ? { role: storedRole } : null)

  // const handleLogin = (role) => {
  //   sessionStorage.setItem('username', role)
  //   // console.log(role);
  //   setUser({ role })
  // }

  const storedRole = sessionStorage.getItem('role')

  const [user, setUser] = useState(storedRole ? { role: storedRole } : null)

  const handleLogin = (role) => {
    sessionStorage.setItem('role', role)
    // console.log(role);
    setUser({ role })
  }

  const handleLogout = () => {
    sessionStorage.removeItem('username')
    setUser(null)
  }

  return (
    // <Router>
    <Routes>
      {/*  STUDENT LOGIN & REGISTRATION ROUTES */}
      <Route
        path="/student/login"
        element={<StudentLoginPage onLogin={handleLogin} />}
      />
      <Route path="/student/register" element={<StudentRegistrationPage1 />} />
      <Route
        path="/student/reg-TermsConditions"
        element={<StudentRegistrationPage2 />}
      />
      <Route
        path="/student/registration"
        element={<StudentRegistrationPage3 />}
      />

      {/*  ADMIN LOGIN */}
      <Route
        path="/admin/login"
        element={<AdminLoginPage onLogin={handleLogin} />}
      />
      <Route path="/admin/login-branch-year" element={<AdminLoginPage2 />} />
      <Route
        path="/superintendent/login-branch-year"
        element={<AdminLoginPage2 />}
      />
      <Route path="/warden/login-branch-year" element={<AdminLoginPage2 />} />

      <Route path="/office/login-branch-year" element={<AdminLoginPage2 />} />


      {/*  ALUMNI LOGIN */}
      <Route path="/alumni/register" element={<AlumniRegistrationPage />} />
      <Route
        path="/alumni/login"
        element={<AlumniLoginPage onLogin={handleLogin} />}
      />

      {/* ADMIN ROUTES */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute user={user} allowedRole="admin">
            <Layout onLogout={handleLogout}>
              <Routes>
                {/* Admin Routes */}
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="change-pass" element={<ChangePasswordAdmin />} />
                {/* Masters */}
                <Route path="masters/class" element={<ClassMaster />} />
                <Route path="masters/rooms" element={<RoomMaster />} />
                <Route path="masters/beds" element={<BedMaster />} />
                <Route path="masters/religion" element={<ReligionMaster />} />
                <Route path="masters/caste" element={<CasteMaster />} />
                {/* <Route path="masters/sub-caste" element={<SubCasteMaster />} /> */}
                <Route path="masters/category" element={<CategoryMaster />} />
                <Route path="masters/events" element={<EventMaster />} />
                <Route path="masters/fee" element={<FeeMaster />} />
                <Route path="masters/fee-amt" element={<FeeAmountMaster />} />
                <Route
                  path="masters/terms-condition"
                  element={<TermsAndConditionMaster />}
                />
                {/* Admin Pending List */}
                <Route path="reg-app-pending" element={<RegAppPendingList />} />
                <Route path="reject-stud" element={<RejectedStudentList />} />
                <Route path="pend-interv" element={<PendingInterviewList />} />
                <Route
                  path="fee-app-pending"
                  element={<HostelFeeAppPendingList />}
                />
                <Route path="document-pending" element={<DocumentAppPendingList />} />
                <Route path="document-rejected" element={<DocumentRejectedStudentList />} />
                <Route path="room-allot-pending" element={<PendingRoomAllotment />} />
                <Route
                  path="leave-app-pending"
                  element={<LeaveAppPendingList />}
                />
                <Route
                  path="complaint-app-pending"
                  element={<ComplaintAppPendingList />}
                />
                <Route
                  path="alumni-app-pending"
                  element={<AlumniAppPendingList />}
                />
                {/* Admin Approved List */}
                <Route path="reg-apprv" element={<RegApprovedList />} />
                <Route path="pass-inter" element={<InterviewPassedList />} />
                <Route path="fee-apprv" element={<HostelFeeApprovedList />} />
                <Route path="document-approved" element={<DocumentApprovedList />} />
                <Route path="leave-apprv" element={<LeaveAppList />} />
                <Route
                  path="concession-fee-apprv"
                  element={<ConcessionApprovedList />}
                />
                <Route path="alumni-apprv" element={<AlumniApprovedList />} />
                {/* ====Room Change===== */}
                <Route path="room-change" element={<StudentRoomChange />} />
                <Route path="room-allotment" element={<RoomAllotmentList />} />
                <Route path="room-history" element={<RoomChangedHistory />} />
               
                <Route path="room-alloc" element={<RoomAllocationList />} />
                {/* Admin Attendance */}
                <Route
                  path="attendance-daily"
                  element={<StudentDailyAttendance />}
                />
                <Route
                  path="attendance-attended"
                  element={<AttendedStudentList />}
                />
                <Route
                  path="event-attendance"
                  element={<StudentEventAttendance />}
                />
                <Route path="event-attended" element={<EventAttendedList />} />
                <Route
                  path="mandir-attendance"
                  element={<StudentMandirAttendance />}
                />
                <Route
                  path="mandir-attended"
                  element={<MandirAttendedList />}
                />
                <Route
                  path="create-certificate"
                  element={<CreateCertificate />}
                />
                <Route path="reg-control" element={<RegistrationControl />} />
                {/* ================================ */}
                <Route path="job-post" element={<JobPost />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />


    {/* OFFICE ROUTES */}
     <Route path="/office/*"
        element={
    <ProtectedRoute user={user} allowedRole="office">
      <Layout onLogout={handleLogout}>
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="change-pass" element={<ChangePasswordAdmin />} />
          <Route path="change-pass" element={<ChangePasswordAdmin />} />

           {/* Admin Pending List */}
                <Route path="reg-app-pending" element={<RegAppPendingList />} />
                <Route path="reject-stud" element={<RejectedStudentList />} />
                {/* <Route path="document-pending" element={<DocumentAppPendingList />} />
                <Route path="document-rejected" element={<DocumentRejectedStudentList />} /> */}
                {/* <Route path="pend-interv" element={<PendingInterviewList />} /> */}
                <Route
                  path="fee-app-pending"
                  element={<HostelFeeAppPendingList />}
                />
                {/* <Route
                  path="leave-app-pending"
                  element={<LeaveAppPendingList />}
                />
                <Route
                  path="complaint-app-pending"
                  element={<ComplaintAppPendingList />}
                />
                <Route
                  path="alumni-app-pending"
                  element={<AlumniAppPendingList />}
                /> */}
                {/* Admin Approved List */}
                <Route path="reg-apprv" element={<RegApprovedList />} />
                {/* <Route path="pass-inter" element={<InterviewPassedList />} /> */}
                <Route path="fee-apprv" element={<HostelFeeApprovedList />} />
                {/* <Route path="document-approved" element={<DocumentApprovedList />} /> */}
                {/* <Route path="leave-apprv" element={<LeaveAppList />} /> */}
                <Route
                  path="concession-fee-apprv"
                  element={<ConcessionApprovedList />}
                />
                {/* <Route path="alumni-apprv" element={<AlumniApprovedList />} /> */}
        </Routes>
      </Layout>
    </ProtectedRoute>
  }
/>


      {/* WARDEN ROUTES */}
      <Route
        path="/warden/*"
        element={
          <ProtectedRoute user={user} allowedRole="warden">
            <Layout onLogout={handleLogout}>
              <Routes>
                {/* Warden Routes */}
                <Route path="dashboard" element={<Dashboard />} />

                {/* Admin Pending List */}
                <Route path="reg-app-pending" element={<RegAppPendingList />} />
                <Route path="reject-stud" element={<RejectedStudentList />} />
                <Route
                  path="fee-app-pending"
                  element={<HostelFeeAppPendingList />}
                />
                <Route
                  path="leave-app-pending"
                  element={<LeaveAppPendingList />}
                />
                <Route
                  path="complaint-app-pending"
                  element={<ComplaintAppPendingList />}
                />

                {/* Admin Approved List */}
                <Route path="reg-apprv" element={<RegApprovedList />} />
                <Route path="fee-apprv" element={<HostelFeeApprovedList />} />
                <Route path="leave-apprv" element={<LeaveAppList />} />

                {/* Admin Attendance */}
                <Route
                  path="attendance-daily"
                  element={<StudentDailyAttendance />}
                />
                <Route
                  path="attendance-attended"
                  element={<AttendedStudentList />}
                />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* SUPERINTENDENT ROUTES */}
      <Route
        path="/superintendent/*"
        element={
          <ProtectedRoute user={user} allowedRole="superintendent">
            <Layout onLogout={handleLogout}>
              <Routes>
                {/* Superintendent Routes */}
                <Route path="dashboard" element={<Dashboard />} />

                {/* Masters */}
                <Route path="masters/class" element={<ClassMaster />} />
                <Route path="masters/rooms" element={<RoomMaster />} />
                <Route path="masters/beds" element={<BedMaster />} />
                <Route path="masters/religion" element={<ReligionMaster />} />
                <Route path="masters/caste" element={<CasteMaster />} />
                {/* <Route path="masters/sub-caste" element={<SubCasteMaster />} /> */}
                <Route path="masters/events" element={<EventMaster />} />
                <Route path="masters/fee" element={<FeeMaster />} />
                <Route path="masters/fee-amt" element={<FeeAmountMaster />} />

                {/* Admin Pending List */}
                <Route path="reg-app-pending" element={<RegAppPendingList />} />
                <Route path="reject-stud" element={<RejectedStudentList />} />
                <Route
                  path="fee-app-pending"
                  element={<HostelFeeAppPendingList />}
                />
                <Route
                  path="leave-app-pending"
                  element={<LeaveAppPendingList />}
                />
                <Route
                  path="complaint-app-pending"
                  element={<ComplaintAppPendingList />}
                />

                {/* Admin Approved List */}
                <Route path="reg-apprv" element={<RegApprovedList />} />
                <Route path="fee-apprv" element={<HostelFeeApprovedList />} />
                <Route path="leave-apprv" element={<LeaveAppList />} />

                {/* ====Room Change===== */}
                <Route path="room-change" element={<StudentRoomChange />} />
                <Route path="room-allotment" element={<RoomAllotmentList />} />
                <Route path="room-history" element={<RoomChangedHistory />} />

                {/* Admin Attendance */}
                <Route
                  path="attendance-daily"
                  element={<StudentDailyAttendance />}
                />
                <Route
                  path="attendance-attended"
                  element={<AttendedStudentList />}
                />

                <Route
                  path="create-certificate"
                  element={<CreateCertificate />}
                />
                <Route path="reg-control" element={<RegistrationControl />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ALUMNI ROUTES */}
      <Route
        path="/alumni/*"
        element={
          <ProtectedRoute user={user} allowedRole="alumni">
            <AlumniLayout onLogout={handleLogout}>
              <Routes>
                {/* alumni Routes */}
                <Route path="creation" element={<AlumniCreation />} />
                <Route path="dashboard" element={<AlumniDashboard />} />
                <Route path="job-post" element={<AlumniJobPost />} />
                <Route path="profile" element={<AlumniProfile />} />
              </Routes>
            </AlumniLayout>
          </ProtectedRoute>
        }
      />

      {/* STUDENT ROUTES */}
      <Route
        path="/student/*"
        element={
          <ProtectedRoute user={user} allowedRole="student">
            <StudentLayout onLogout={handleLogout}>
              <Routes>
                <Route path="std-hostelPay" element={<HostelFeePayment />} />
                <Route path="std-dashboard" element={<StudentDashboard />} />
                <Route path="details-profile" element={<ProfileDetails />} />
                <Route
                  path="details-roomBed"
                  element={<AllotedRoomBedDetails />}
                />
                <Route path="details-payment" element={<PaymentDetails />} />
                <Route path="app-leave" element={<LeaveApplication />} />
                <Route
                  path="app-complaint"
                  element={<ComplaintApplication />}
                />
                <Route path="report-attend" element={<AttendanceReport />} />
                <Route
                  path="report-mandir-attend"
                  element={<MandirAttendanceReport />}
                />
                <Route
                  path="report-event-attend"
                  element={<EventAttendanceReport />}
                />
                <Route path="std-job-post" element={<AllJobPostDetails />} />
              </Routes>
            </StudentLayout>
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/student/login" replace />} />
    </Routes>
    // </Router>
  )
}

// ========ADMIN LAYOUT=================
function Layout({ children, onLogout }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev)

  // const storedRole = sessionStorage.getItem('username')

   const storedRole = sessionStorage.getItem('role')

  return (
    <div className="app">
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        role={storedRole}
      />
      <div
        className={`main-content ${isSidebarOpen ? 'blurred' : ''}`}
        onClick={() => isSidebarOpen && toggleSidebar()}
      >
        <Header toggleSidebar={toggleSidebar} onLogout={onLogout} />
        {children}
        <Footer />
      </div>
    </div>
  )
}

// ========STUDENT LAYOUT=================
function StudentLayout({ children, onLogout }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev)

  return (
    <div className="app">
      <StudentSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        className={`main-content ${isSidebarOpen ? 'blurred' : ''}`}
        onClick={() => isSidebarOpen && toggleSidebar()}
      >
        <StudentHeader toggleSidebar={toggleSidebar} onLogout={onLogout} />
        {children}
        <StudentFooter />
      </div>
    </div>
  )
}

// ========ALUMNI LAYOUT=================
function AlumniLayout({ children, onLogout }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev)

  const storedRole = sessionStorage.getItem('username')

  return (
    <div className="app">
      <AlumniSidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        role={storedRole}
      />
      <div
        className={`main-content ${isSidebarOpen ? 'blurred' : ''}`}
        onClick={() => isSidebarOpen && toggleSidebar()}
      >
        <AlumniHeader toggleSidebar={toggleSidebar} onLogout={onLogout} />
        {children}
        <AlumniFooter />
      </div>
    </div>
  )
}
